import viewGroupsStylesStyles from './view-groups-styles.styles.css?inline';
import { unsafeCSS } from 'lit';
import { listSharedStyles } from '../../styles/list-shared-styles';
import {
  fillHeightTableStyles,
  fillHeightHostStyles,
} from '../../styles/fill-height-table.styles';

export const styles = [
  listSharedStyles,
  fillHeightTableStyles,
  fillHeightHostStyles,
  unsafeCSS(viewGroupsStylesStyles),
];
